// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.0375 7.57319L16.4272 1.96289L12.2309 6.15922L17.8412 11.7695L22.0375 7.57319Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16.427 13.1837L10.817 7.57373L1.99976 16.3904V22.0007L7.61005 22.0007L16.427 13.1837Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12.6815 22.0007H22.2245V20.0007L12.6815 20.0007V22.0007Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-edit-2-filled')
export default class Edit2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'edit-2-filled',
    }
  }
}
